import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

interface MasterLayoutProps {
  /** Page content. When omitted, the matched child route is rendered (<Outlet />). */
  children?: ReactNode;
}

/** Public website shell: header + page content + footer. */
export default function FrontendMasterLayout({ children }: MasterLayoutProps) {
  return (
    <div className="min-h-screen bg-background-50 w-full overflow-x-clip flex flex-col">
      <Header />
      <main className="w-full flex-1">
        {children ?? <Outlet />}
      </main>
      <Footer />
    </div>
  );
}
